import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BatteryAlertOutlinedIcon from '@mui/icons-material/BatteryAlertOutlined';
import RadioOutlinedIcon from '@mui/icons-material/RadioOutlined';
import HearingIcon from '@mui/icons-material/Hearing';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import SensorsOffOutlinedIcon from '@mui/icons-material/SensorsOffOutlined';

import MaintenanceDashboardBlock from './MaintenanceDashboardBlock';
import {
  DARK_GREY,
  DESERT_FLOWER,
  AQUA_MARINE,
} from '../../DashboardModal/dashboardColors';

const statusIcons = {
  audio: <HearingIcon />,
  fm_reception: <SettingsInputAntennaIcon />,
  no_fm: <RadioOutlinedIcon />,
  low_battery: <BatteryAlertOutlinedIcon />,
  inactive: <SensorsOffOutlinedIcon />,
};

const SystemStatusBlock = ({ items, installedSensors, t, isHebrew }) => (
  <MaintenanceDashboardBlock
    title={t('system_status') || 'System Status'}
    icon={<SettingsInputAntennaIcon />}
    className='system-status-block'
    headerAction={
      <Typography className='system-status-total'>
        <Box
          component='span'
          sx={{
            direction: isHebrew ? 'rtl' : 'ltr',
            unicodeBidi: 'isolate',
            display: 'inline-flex',
            alignItems: 'baseline',
            gap: '4px',
          }}
        >
          <Box component='span'># {t('installed') || 'Installed'}:</Box>
          <Box component='span' dir='ltr' sx={{ color: AQUA_MARINE }}>
            {installedSensors}
          </Box>
        </Box>
      </Typography>
    }
  >
    <Box className='maintenance-key-value-list'>
      {items.map(({ key, label, value }) => {
        const hasIssues = value > 0;

        return (
          <Box
            className={`maintenance-key-value-row ${
              hasIssues ? 'has-issues' : ''
            }`}
            key={label}
          >
            <Box className='maintenance-key-value-label-group'>
              <Box className='maintenance-key-value-icon'>
                {statusIcons[key]}
              </Box>
              <Typography
                className='maintenance-key-value-label'
                sx={{
                  color: DARK_GREY,
                  direction: isHebrew ? 'rtl' : 'ltr',
                  unicodeBidi: 'isolate',
                }}
              >
                {label}
              </Typography>
            </Box>
            <Typography
              className='maintenance-key-value-value'
              sx={{ color: value > 0 ? DESERT_FLOWER : DARK_GREY }}
            >
              {value}
            </Typography>
          </Box>
        );
      })}
    </Box>
  </MaintenanceDashboardBlock>
);

SystemStatusBlock.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
  installedSensors: PropTypes.number,
  t: PropTypes.func.isRequired,
  isHebrew: PropTypes.bool,
};

SystemStatusBlock.defaultProps = {
  installedSensors: 0,
  isHebrew: false,
};

export default SystemStatusBlock;
